/* src/app/podcast/podcast.component.scss */
.podcast-page {
  position: absolute;
  display: flex;
  top: 150px;
  bottom: 120px;
  left: 0;
  right: 0;
  z-index: 2;
  background-color: #262933;
}
.podcast-page a {
  color: #FFF;
  font-family: "Campton-light";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  text-decoration-line: underline;
  margin-bottom: 20px;
}
.podcast-page h1 {
  font-size: 34px;
  font-family: "Campton-Bold";
  font-style: normal;
  line-height: 46px;
  font-weight: 700px;
}
.podcast-page h1.reference-header {
  font-family: Campton;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  margin: 15px 0px;
}
.podcast-page h2.publish-date {
  color: #999;
  font-family: "Campton-Light";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  margin-bottom: 25px;
  margin-top: 10px;
}
.podcast-page .episode-container {
  margin: 0px 100px;
  border-radius: 20px;
  background: #3D3F47;
  display: flex;
  padding: 50px;
  height: 690px;
  text-align: left;
  gap: 75px;
}
.podcast-page .episode-container .notes {
  overflow-y: auto;
}
.podcast-page .podcast-image img {
  border-radius: 10px;
}
.podcast-page .blocker {
  position: absolute;
  height: 150px;
  top: 0px;
  width: 100%;
  background-color: #262933;
}
.player-container {
  position: fixed;
  bottom: 0px;
  width: 100%;
}
.player {
  padding: 0px 175px 0px 100px;
}
@media (max-height: 920px) {
  .podcast-page .episode-container {
    height: 500px;
  }
}
/*# sourceMappingURL=podcast.component.css.map */
